import React, { useState, useEffect } from 'react';
import InputStyled from './Input.styled';

interface RefObject<T> {
  readonly current: T | null;
}

interface Props {
  className?: string;
  type: 'text' | 'password';
  label: string;
  placeholder?: string;
  id: string;
  name: string;
  defaultValue?: string;
  autoFocus?: boolean;
  autoComplete?: string;
  elRef?: RefObject<HTMLInputElement>;
  _onChange?: (e: React.ChangeEvent<Element> | HTMLInputElement) => void;
  _onBlur?: (e: React.FocusEvent<Element> | HTMLInputElement) => void;
  _onKeyDown?: (e: React.KeyboardEvent<Element> | HTMLInputElement) => void;
  hasError?: boolean;
}

const Input = ({
  className,
  label,
  id,
  name,
  type,
  elRef,
  placeholder,
  autoFocus = false,
  autoComplete,
  defaultValue = '',
  _onChange,
  _onBlur,
  _onKeyDown,
  hasError = false,
}: Props) => {
  const [value, setValue] = useState(defaultValue);
  useEffect(() => setValue(defaultValue), [defaultValue]);

  return (
    <InputStyled className={className} hasError={hasError}>
      <label htmlFor={id}>{label}</label>
      <input
        type={type}
        id={id}
        name={name}
        ref={elRef}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          setValue(e.target.value);
          if (_onChange) _onChange(e);
        }}
        onBlur={e => {
          setValue(e.target.value);
          if (_onBlur) _onBlur(e);
        }}
        onKeyDown={e => {
          if (_onKeyDown) _onKeyDown(e);
        }}
      />
    </InputStyled>
  );
};

export default Input
